/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

angular.module('groupList').factory('UserGroupListItem', ['ConnectionGroup', function defineUserGroupListItem(ConnectionGroup) {
    var UserGroupListItem = function UserGroupListItem(template) {

        // Use empty object by default
        template = template || {};

        /**
         * The unique identifier associated with the connection or connection
         * group this item represents.
         *
         * @type String
         */
        this.identifier = template.identifier;

        /**
         * The human-readable display name of this item.
         *
         * @type String
         */
        this.name = template.name;

        /**
         * All children items of this item. If this item contains no children,
         * this will be an empty array.
         *
         * @type GroupListItem[]
         */
        this.children = template.children || [];

        /**
         * Whether this item represents a connection. If this item represents
         * a connection group, this MUST be false.
         *
         * @type Boolean
         */
        this.isUser = template.isUser;

        /**
         * Whether this item represents a connection group. If this item
         * represents a connection, this MUST be false.
         *
         * @type Boolean
         */
        this.isUserGroup = template.isUserGroup;

        /**
         * Whether the children items should be displayed.
         *
         * @type Boolean
         */
        this.isExpanded = template.isExpanded;

        /**
         * The connection or connection group whose data is exposed within
         * this GroupListItem.
         *
         * @type User|Null
         */
        this.wrappedItem = template.wrappedItem;

    };

    UserGroupListItem.fromUser = function fromUser(user) {

        // Return item representing the given connection
        return new UserGroupListItem({

            // Identifying information
            name       : user.user.username,

            // Type information
            isUser      : true,
            isUserGroup : false,

            children : null,

            isExpanded: false,

            // Wrapped item
            wrappedItem : user

        });

    };

    UserGroupListItem.fromUsers = function fromUsers(usersGroup) {

        return new UserGroupListItem({

            // Identifying information
            name       :  usersGroup.name,

            // Type information
            isUser      : false,
            isUserGroup : true,

            // Already-converted children
            children : usersGroup.users,

            isExpanded: false,

            // Wrapped item
            wrappedItem : null

        });
    };

    UserGroupListItem.buildUserTree = function buildUserTree(users) {

        var userNameMatcher = /^PT_?ACCESS([0-9]+)$/i;

        var userGroupList = [];
        var groupNames = [];

        angular.forEach(users, function buildGroups(user) {
            var userName = userNameMatcher.exec(user.user.username);
            if(userName != null){
                var nameNum = parseInt(userName[1]);
                nameNum = Math.floor((nameNum/100))*100;
                var rangeIndex = groupNames.indexOf(nameNum);
                if(rangeIndex > -1){
                    userGroupList[rangeIndex].children.push(UserGroupListItem.fromUser(user));
                }else{
                    var groupName = "PTACCESS"+nameNum+" - "+"PTACCESS"+(nameNum+99);
                    userGroupList.push(UserGroupListItem.fromUsers({name: groupName, users: [UserGroupListItem.fromUser(user)]}));
                    groupNames.push(nameNum);
                }
            }else{
                var otherIndex = groupNames.indexOf("Other");
                if(otherIndex > -1){
                    userGroupList[otherIndex].children.push(UserGroupListItem.fromUser(user));
                }else{
                    userGroupList.push(UserGroupListItem.fromUsers({name: "Other", users: [UserGroupListItem.fromUser(user)]}));
                    groupNames.push("Other");
                }
            }
        });

        userGroupList.sort(function(a, b){
            if(a.isUserGroup && b.isUserGroup){
                if(a.name == b.name){
                    return 0;
                }else if(a.name == 'Other'){
                    return 1;
                }else if(b.name == 'Other'){
                    return -1;
                }else{
                    return a.name.localeCompare(b.name);
                }
            }
            if(a.isUser && b.isUserGroup){
                return 1;
            }
            if(a.isUserGroup && b.isUser){
                return -1;
            }
        });

        return UserGroupListItem.fromUsers({name: "rootItem", users: userGroupList});

    };

    return UserGroupListItem;
}]);